export default "__VITE_ASSET__kIaJ9CZK__"